import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MakeQuestionAttempted } from "../../../Client/request";
import { createMockTestPayload } from "../utils/apiPayload";

export const useWritingSubmission = ({
  quest,
  questData,
  value,
  questionsTime,
  MockTestAttemptID,
  ExamId,
  step,
  totalQuestions,
  setStep,
  setValue,
  setDisabled,
  stopStopwatch,
  resetQuestionTimer,
  endTestAndTimeout,
  submitTriggerRef
}) => {
  const [networkError, setNetworkError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (submitTriggerRef && submitTriggerRef.current && questData) {
      handleNext();
      submitTriggerRef.current = false;
    }
  }, [submitTriggerRef.current, questData]);

  const handleNext = () => {
    // if (value.trim() === "") {
    //   return;
    // }
    
    if (!questData) {
      console.warn("questData is undefined, skipping submission");
      return;
    }
    
    setDisabled(true);
    stopStopwatch();

    const finalPayload = createMockTestPayload({
      quest,
      questData,
      userResponse: value,
      marksObtained: 100,
      timeTaken: questionsTime / 1000,
      commulative: null,
      mockTestAttemptID: MockTestAttemptID,
      examId: ExamId,
      aiResponse: {},
      audioUrl: null,
      selectedAnswers: [],
      correctAnswers: [],
      userOrder: [],
      majorAspects: questData?.MajorAspects ? questData.MajorAspects : [],
      minorAspects: questData?.MinorAspects ? questData.MinorAspects : [],
      optionNames: []
    });

    MakeQuestionAttempted(finalPayload).then((res) => {
      setValue("");
      if (res.error) {
        setNetworkError(true);
        setTimeout(() => {
          navigate("/Mocktest");
        }, 2000);
      } else {
        if (!quest?.IsAttempted) {
          quest.IsAttempted = true;
        }
      }
      if (step === totalQuestions) {
        endTestAndTimeout().then(() => {});
      }
    });

    resetQuestionTimer();
    if (step !== totalQuestions) {
      setStep(step + 1);
    }
  };

  return {
    networkError,
    setNetworkError,
    handleNext
  };
};
